import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const SkeletonLoader = (props) => {
  return (
    <Skeleton
      baseColor="rgba(39, 38, 43, 0.65)"
      borderRadius={12}
      inline
      highlightColor="#27262B"
      {...props}
    />
  );
};
